import React from 'react';
import Sidebar from './Sidebar';
import { UserSyncProvider } from '../auth/UserSyncProvider';
import { AuthEventListener } from '../auth/AuthEventListener';
import { LayoutProvider, useLayout } from '@/contexts';

interface LayoutProps {
  children: React.ReactNode;
}

const LayoutContent: React.FC<LayoutProps> = ({ children }) => {
  const { getMainContentStyle } = useLayout();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Sidebar />
      <main
        className="min-h-screen"
        style={getMainContentStyle()}
      >
        <div className="h-full">
          {children}
        </div>
      </main>
    </div>
  );
};

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <UserSyncProvider>
      <AuthEventListener>
        <LayoutProvider>
          <LayoutContent>{children}</LayoutContent>
        </LayoutProvider>
      </AuthEventListener>
    </UserSyncProvider>
  );
};

export default Layout;
